import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CreditCardFace } from "../icons";
import { Table } from "react-bootstrap";
import { useState, useEffect } from "react";
import { SBDKAPI } from "@api";

const Container = styled.div`
  padding: 1em;
  border: white;
  border-width: 1px;
  border-style: solid;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 5%), 0px 2px 4px rgb(0 0 0 / 10%);
  border-radius: 8px;

  & th {
    border: none !important;
  }
`;

const Subtitle = styled.div`
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #edeeee ;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #5E514D;
`;

const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  width: 100%;
  font-size: 0.9em;
`;

const Date = styled.div`
  width: 50%;
  text-align: left;

  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #8A8D8F;
`;

const Next = styled.a`
  width: 50%;
  text-align: right;
  color: #f2a900 !important;
  text-decoration: none !important;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;

  &:hover {
    opacity: .8;
  }
`;

const Header = styled.div`
  font-style: normal;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: #5E514D;
  margin-bottom: 24px;

  .title{
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    color: #5E514D;
  }
`;

const Icon = styled.div`
  width: 36px;
  height: 36px;
  background: rgba(94, 81, 77, 0.1);
  border-radius: 0px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;

.icon{
  width: 18px;
  height: 18px;
}
`;

const TopContent = styled.div`
  border-bottom: 1px solid #edeeee ;
`;

const BottomContent = styled.div`
  border-bottom: 1px solid #edeeee ;
`;

const THead = styled.thead`
  color: #85714d;

  
  & th {
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
  }
`;

const Tbody = styled.tbody`
  color: #5E514D;

  & td {
    padding: 14px  0 16px 0;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }
`;

const THead2 = styled.thead`
  color: #85714d;

  
  & th {
    padding: 16px 0 0 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
  }
`;

const Tbody2 = styled.tbody`
  color: #5E514D;

  & td {
    padding: 14px 0 35.5px 0;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }
`;

const SBDK = function () {
  const [SBDK, setSBDK] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const loadSBDK = async () => {
      const { data } = await SBDKAPI();
      setSBDK(data.data);
    };

    if (SBDK === null) {
      loadSBDK();
    }
  });

  return (
    <Container className="h-100">
      <Header>
        <div className="col-8 d-flex justify-content-start align-items-center">
          <Icon>
            <CreditCardFace
              fill="#5E514D"
              className="icon"
            />
          </Icon>
          <div className="title color-brown">{t("sbdk")}</div>
        </div>
      </Header>
      <Subtitle className="text-start">
        {t("basic_loan_interest_rate")}
      </Subtitle>
      <div className="text-start">
        <TopContent>
          <Table borderless className="mb-0">
            <THead>
              <tr>
                <th>{t("corporate_credit")}</th>
                <th>{t("retail_credit")}</th>
                <th>{t("micro_credit")}</th>
              </tr>
            </THead>
            <Tbody>
              <tr>
                <td>{SBDK != null ? SBDK[0].kredit_korporasi : "0"}%</td>
                <td>{SBDK != null ? SBDK[0].kredit_ritel : "0"}%</td>
                <td>{SBDK != null ? SBDK[0].kredit_mikro : "0"}%</td>
              </tr>
            </Tbody>
          </Table>
        </TopContent>
        <BottomContent>
          <Table borderless>
            <THead2>
              <tr>
                <th colSpan="1">{t("consumption_credit")}</th>
              </tr>
            </THead2>
            <THead2>
              <tr>
                <th style={{ width: "40%" }}>KPR</th>
                <th>Non-KPR</th>
              </tr>
            </THead2>
            <Tbody2>
              <tr>
                <td>{SBDK != null ? SBDK[0].kredit_konsumsi_KPR : "0"}%</td>
                <td>{SBDK != null ? SBDK[0].non_KPR : "0"}%</td>
              </tr>
            </Tbody2>
          </Table>
        </BottomContent>
      </div>
      <Footer>
        <Date></Date>
        <Next href={"/sbdk"}>{t("more")}</Next>
      </Footer>
    </Container>
  );
};

export default SBDK;
